export default {
  updateDate: '更新时间',
  company: '所属公司',
  channelType: '三方通道类型',
  lastcreator: '最后操作人',
  supplier: '供应商',
  subotp: '提交验证码',
  receipt: '回执',

  zalopayId: 'zalo账号',
  enterotp: '请输入验证码',
  payinfo: '收款方信息',
  paycode: '收款二维码',
  paycode1: '收款',
  paycode2: '出款',
  transCode: '交易码',

  confirm: '提交',
  serialNumber: '设备号',
  userName: '账号所属用户名',
  phone: '手机号码',
  connectionStatus: '连接状态',
  limits: '当日限制额度',
  monthLimits: '当月限额',
  receivedDayMoney: '当日已收金额',
  receivedTotalMoney: '已收总金额',
  id: 'id',
  payOrder: '交易号',
  deviceOrder: '设备号',
  payType: '转账类型',
  payMoney: '交易金额',
  remark: '描述',
  callbackStatus: '回调状态',
  createTime: '创建日期',
  tranid: '交易号',
  tranType: '转账类型',
  amount: '交易金额',
  description: '描述',
  updates: '上传',
  exportIn: '导入',
  orderNumberTotal: '交易数量',
  paymentAmountTotal: '收到的总金额',
  history: '历史记录',
  bankName: '银行名称',
  bankAccount: '银行卡号',
  bankCode: '银行编码',
  payName: '收款方名字',
  loginAccount: '登录账号',
  proQrStatus: '通用码状态',
  bankQrStatus: '银行扫码状态',
  momoBankStatus: 'momo银行状态',
  bankTransferStatus: '银行卡转卡状态',
  apiStatus: 'api拉取记录状态',
  momo_bankStatus: 'momobank银行状态',
  zalobankStatus: 'zalobank银行状态',
  vtpbankStatus: 'vtpbank银行状态',
  balance: '账户余额',
  successTodayAmount: '当天成功交易金额',
  content: '内容',
  source: '来源',
  accountNumber: '交易金额',
  io: ' 转账类型',
  partnerPhone: '出款手机号',
  finishTime: '转账时间',
  fee: '手续费',
  apptrandsId: '官方订单号',
  sourceType: '记录来源',
  systemOrderNo: '系统订单号',
  status: '交易状态',
  senderAccount: '提款账号',
  senderName: '提款人名称',
  senderBankCode: '提款银行',
  receiverNumber: '收款账号',
  receiverName: '收款人姓名',
  receiverBankCode: '收款银行',
  createDate: '操作时间',
  createBy: '操作人',
  confirmDate: '确认时间',
  confirmBy: '提款操作人',
  error: '错误信息',
  payBankId: '出款银行id',
  offstatus: '状态',
  changestate: '是否开启',
  changestateoff: '是否关闭',
  password: '密码',
  minimumAmount: '最小收款金额',
  maximumAmount: '最大收款金额',
  withdrawTodayAmount: '当日提款金额',
  description: '操作描述',
  ipAddress: '操作IP地址',
  beforeOperation: '操作前数据',
  afterOperation: '操作后数据',
  LoginBackground: '登入后台',
  LoginIP: '登入IP',
  PayforIP: '代付IP',
  pullBalance: '拉取余额',
  SelectedFile: '已选择文件',
  selectFile: '选择文件',
  btnLeft: '请缓慢向左摇头',
  btnRight: '请缓慢向右摇头',
  btnZoomIn: '拉近手机',
  btnZoomOut: '拉远手机',
  btnFrontAndBlink: '请正视摄像头并眨眼',
  btnRedLight: '红光',
  btnYellowLight: '黄光',
  btnBlueLight: '蓝光',
  facevideoTip: '当前没有采录到视频',
  facevideo: '人脸视频',
  tip: '(TCB必须上传视频)',
  btnOrangeLight: '橙光',
  btnFront: '请正视摄像头',
  momoBankStatus: 'MOMO状态',
  bankPayType: '代收银行类型',
  connectionStatusOption: [
    {
      value: '',
      label: '全部'
    },
    {
      value: 0,
      label: '断开'
    },
    {
      value: 1,
      label: '链接'
    }
  ],
  add_connectionStatusOption: [
    {
      value: 0,
      label: '断开'
    },
    {
      value: 1,
      label: '链接'
    }
  ],
  callbackStatusOption: [
    {
      value: 2,
      label: '已回调'
    },
    {
      value: 1,
      label: '未回调'
    }
  ],
  statusOption: [
    {
      value: 1,
      label: '开启'
    },
    {
      value: 2,
      label: '关闭'
    }
  ],
  transpayTo: [
    {
      value: 0,
      label: '出款'
    },
    {
      value: 1,
      label: '收款'
    }
  ],
  b_transpayTo: [
    {
      value: 1,
      label: '收款'
    },
    {
      value: 2,
      label: '提款'
    },
    {
      value: 3,
      label: '代付'
    }
  ],
  recordStatus: [
    {
      value: 0,
      label: '处理中'
    },
    {
      value: 1,
      label: '失败'
    },
    {
      value: 2,
      label: '成功'
    }
  ],
  paystatus: [
    {
      value: 0,
      label: '处理中'
    },
    {
      value: 1,
      label: '失败'
    },
    {
      value: 2,
      label: '成功'
    }
  ],
  rules: {
    //设备号
    serialNumber: '请输入设备号',
    //手机号
    phone: '请输入手机号',
    //连接状态
    connectionStatus: '请选择连接状态',
    //当天收款限额
    limits: '请输入当天收款限额',
    //当月收款限额
    monthLimits: '请输入当月收款限额',
    company: '请输入所属公司'
  },
  mo_history: {
    id: 'id',
    serialNumber: '手机编号',
    phone: '收款手机号',
    userName: '收款人名称',
    tranid: '交易号',
    tranType: '收款类型',
    amount: '金额',
    description: '描述',
    partnerId: '转账手机号',
    partnerName: '转账方名称',
    payTime: '支付时间',
    createTime: '创建时间',
    merchantOrderNo: '商户订单号',
    merchantNo: '商户号',
    merchantName: '商户名称',
    transactionDate: '收款时间'
  },
  all: {
    del: '批量删除',
    edit: '批量修改',
    offorturn: '批量开启关闭:'
  },
  down: {
    a1: '选取要上传的 .xlsx 档',
    a2: '或将 .xlsx 档案拖拉到这里',
    a3: '下载模版',
    close: '关闭',
    confirm: '确认',
    selectfile: '请先选择文件',
    ImportSuccess: '导入成功',
    Importfailed: '导入失败'
  },
  withdrawal: {
    paystatus: [
      {
        value: -1,
        label: 'failed'
      },
      {
        value: 1,
        label: 'success'
      }
    ],
    transferTypes: ['向外部账户转账', '向关联账户转账', '内部账户转账', 'momo代付'],
    orderNumberTotal: '实收金额',
    realAmount: '总金额',
    totalfee: '手续费',
    statistics: '统计',
    appTransId: '系统单号',
    phone: '电话',
    serial: '设备号',
    transId: 'ZALO订单号',
    payId: '账号',
    receiverNumber: '收款账号',
    senderNumber: '提款账号',
    receiverName: '收款人姓名',
    amount: '金额',
    fee: '手续费',
    total: '总金额',
    status: '订单状态',
    message: '描述',
    error: '备注信息',
    creator: '操作人',
    created: '操作时间',
    momo: {
      orderNumberTotal: '实收金额',
      realAmount: '总金额',
      totalfee: '手续费',
      statistics: '统计',
      fulldata: '系统单号',
      tranId: 'MOMO订单号',
      accountPhone: 'momo账号',
      rowCardNum: '收款卡号',
      partnerName: '收款人姓名',
      originalAmount: '到账金额',
      fee: '手续费',
      amount: '总金额',
      sodu: '转账前余额',
      balance: '转账后余额',
      errorDesc: '描述',
      type: '转账类型',
      username: '操作人',
      status: '订单状态',
      createTime: '创建时间',
      serial: '设备序列号'
    }
  },
  autoWithdrawalAmount: '自动取款金额',
  reservedAmount: '账号预留金额',
  autoWithdrawalStatus: '自动取款状态',
  creatorBy: '创建者',
  accountstatus: '账号状态',
  owner_merchant_no: '所属商户',
  lastAccept: '最后收款时间',
  capsetAmount: '转出月限额',
  loginStatus: '登录状态',
  Normal: '正常',
  Abnormal: '异常',
  totalErrorAccounts: '登录异常数量:'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/device.js